// @flow
import $ from 'jquery';
import JQueryView from '../../../common/JQueryView';
import { on } from '../../../../../admin/views/common/JQueryView';
import type { JQuery } from 'jquery';

export default class SoIndexView extends JQueryView {
  selectedItem: JQuery;

  constructor() {
    super('.modal-dialog');
  }

  @on({ event: 'click', selector: '.item-row' })
  onClickItemRow(event: any) {
    if (this.selectedItem) {
      this.selectedItem.removeClass('selected');
    }
    this.selectedItem = $(event.target).parent();
    this.selectedItem.addClass('selected');
    $('#right-type-stock-option-select-button').removeClass('disabled');
  }

  @on({ event: 'click', selector: '#right-type-stock-option-select-button' })
  onClickRightTypeBasicSelectButton(event: any) {
    event.preventDefault();
    if (this.selectedItem) {
      const itemId = this.selectedItem.attr('data-id');
      location.href = `/company/stock_options/${itemId}/rightholders`;
    } else {
      alert('ストックオプションを選択してください。');
    }
  }
}
